import React from 'react';
import { Icons as I } from '../pack-icons';

/**
 * StatCards — 4-up stats row with sparkline + delta.
 * items: [{ label, value, unit?, delta?, sub?, spark? (number[]) }]
 *
 * Caller decides which fields are populated. Empty/missing → just no chrome shown.
 */
export default function StatCards({ items }) {
  if (!items?.length) return null;
  return (
    <div className="stat-cards">
      {items.map((s, i) => (
        <div key={i} className="card stat-card">
          <div className="stat-head">
            <span className="stat-label">{s.label}</span>
            {typeof s.delta === 'number' && (
              <span className={`stat-delta ${s.delta > 0 ? 'up' : 'down'}`}>
                {s.delta > 0 ? <I.arrowUpR size={10} /> : <I.arrowDownR size={10} />}
                {Math.abs(s.delta)}%
              </span>
            )}
          </div>
          <div className="stat-value">
            <span className="stat-num">{s.value}</span>
            {s.unit && <span className="stat-unit">{s.unit}</span>}
          </div>
          <div className="stat-foot">
            {s.spark?.length > 1 && (
              <svg viewBox="0 0 100 24" preserveAspectRatio="none" className="stat-spark">
                <polyline
                  points={s.spark
                    .map((v, idx) => `${(idx / (s.spark.length - 1)) * 100},${24 - (v / Math.max(...s.spark)) * 22}`)
                    .join(' ')}
                  fill="none"
                  stroke={typeof s.delta === 'number' && s.delta < 0 ? 'var(--danger)' : 'var(--accent)'}
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
              </svg>
            )}
            {s.sub && <span className="stat-sub">{s.sub}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
